// extracted by mini-css-extract-plugin
export var isOverflowHidden = "-x5-";
export var root = "YiF+";
export var rootScrollHidden = "YLrr";
export var rootSearching = "DIJr";